import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../utils/styles';

export const DefaultVariant = ({
  active,
  onClick,
  subLabel,
  isAppFreebieActive,
  isLast,
  title,
  variantsCount,
}) => {
  return (
    <Variant $active={active} onClick={onClick}>
      {title}
      <VariantSubLabel>{subLabel}</VariantSubLabel>
      {isLast && variantsCount !== 1 && (
        <VariantLabel>
          Best value
          {isAppFreebieActive && (
            <>
              {' '}
              + <span>Free gift</span>
            </>
          )}
        </VariantLabel>
      )}
    </Variant>
  );
};

const VariantSubLabel = styled.div`
  font-size: 13px;
  line-height: 16px;
  margin-top: 8px;
`;

const VariantLabel = styled.div`
  font-size: 14px;
  line-height: 1.25;
  height: auto;
  padding: 4px;
  position: absolute;
  left: -1px;
  top: calc(100% + 1px);
  width: calc(100% + 2px);
  display: block;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: #c7c7c7;
  span {
    display: block;
  }
`;

const Variant = styled.button`
  position: relative;
  margin-left: -1px;
  flex: 1;
  flex-direction: column;
  display: flex;
  border: 1px solid #c7c7c7;
  color: rgba(34, 34, 34, 0.5);
  transition: 0.2s ease-out border-color, 0.2s ease-out color;
  height: 76px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  padding: 5px;
  &:hover {
    border-color: ${colors.pink};
    + button {
      border-left-color: ${colors.pink};
    }
  }
  ${p =>
    p.$active &&
    css`
      background: ${colors.lightPink};
      border-color: ${colors.pink};
      color: ${colors.black};
      ${VariantSubLabel} {
        color: ${colors.pink};
      }
      + button {
        border-left-color: ${colors.pink};
      }
      ${VariantLabel} {
        background: ${colors.pink};
      }
    `}
`;
